import SignIn from '@/pages/SignIn'
import StsDescription from '@/pages/StsDescription'
import StsDisclaimer from '@/pages/StsDisclaimer'
import ActiveRepairs from '@/pages/repair/ActiveRepairs'
import ClosedRepairs from '@/pages/repair/ClosedRepairs'
import ActionRequried from '@/pages/repair/ActionRequried'
import NewRepair from '@/pages/repair/NewRepair'
import GeneralReport from '@/pages/reports/GeneralReport'
import ContactList from '@/pages/contacts/ContactList'
import ProcessContact from '@/pages/contacts/ProcessContact'
import MailNotificationList from '@/pages/MailNotificationList'
import PartList from '@/pages/parts/PartList'
import ProcessPart from '@/pages/parts/ProcessPart'
import ProcessRepair from '@/pages/repair/ProcessRepair'
import NewPartRequest from '@/pages/part-request/NewPartRequest'
import PartRequests from '@/pages/part-request/PartRequests'
import NewRemoteSupport from '@/pages/remote-support/NewRemoteSupport'
import RemoteSupportList from '@/pages/remote-support/RemoteSupportList'
import ResetPassword from '@/pages/ResetPassword'
import NewAccountRequest from '@/pages/account-request/NewAccountRequest'
import AccountRequestDecision from '@/pages/account-request/AccountRequestDecision'
import ProcessPartRequest from '@/pages/part-request/ProcessPartRequest'
import ProcessRemoteSupport from '@/pages/remote-support/ProcessRemoteSupport'
import DownloadAttachment from '@/pages/DownloadAttachment'

export const navigationRoutes = [
  {
    path: 'login',
    name: 'SignIn',
    component: SignIn,
    patterns: [
      /\/login$/
    ],
    permissions: []
  }, {
    path: 'sts-description',
    name: 'StsDescription',
    component: StsDescription,
    patterns: [
      /\/sts-description$/
    ],
    permissions: []
  }, {
    path: 'sts-disclaimer',
    name: 'StsDisclaimer',
    component: StsDisclaimer,
    patterns: [
      /\/sts-disclaimer$/
    ],
    permissions: []
  }, {
    path: 'active-repairs',
    name: 'ActiveRepairs',
    component: ActiveRepairs,
    patterns: [
      /\/active-repairs$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
  }, {
    path: 'closed-repairs',
    name: 'ClosedRepairs',
    component: ClosedRepairs,
    patterns: [
      /\/closed-repairs$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
  }, {
    path: 'action-required',
    name: 'ActionRequried',
    component: ActionRequried,
    patterns: [
      /\/action-required$/
    ],
    permissions: ["SUPERVISOR", "SERVICE", "CLIENT"]
  }, {
    path: 'new-repair',
    name: 'NewRepair',
    component: NewRepair,
    patterns: [
      /\/new-repair$/
    ],
    permissions: ["CLIENT"]
  }, {
    path: 'reports/general',
    name: 'GeneralReport',
    component: GeneralReport,
    patterns: [
      /\/reports\/general$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SUSTAINABILITY_MANAGER"]
  }, {
    path: 'contacts',
    name: 'ContactList',
    component: ContactList,
    patterns: [
      /\/contacts$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN"]
  }, {
    path: 'create/contact',
    name: 'ProcessContact',
    component: ProcessContact,
    patterns: [
      /\/create\/contact$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN"]
  }, {
    path: 'edit/contact/:username',
    name: 'ProcessContact',
    component: ProcessContact,
    patterns: [
      /\/edit\/contact\/[-_\w\d]+$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN"]
  }, {
    path: 'profile',
    name: 'ProcessContact',
    component: ProcessContact,
    patterns: [
      /\/profile$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
  },{
    path: 'mail-notification',
    name: 'MailNotificationList',
    component: MailNotificationList,
    patterns: [
      /\/mail-notification$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN"]
  }, {
    path: 'parts',
    name: 'PartList',
    component: PartList,
    patterns: [
      /\/parts$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN",]
  }, {
    path: 'create/part',
    name: 'ProcessPart',
    component: ProcessPart,
    patterns: [
      /\/create\/part$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN"]
  }, {
    path: 'edit/part/:id',
    name: 'ProcessPart',
    component: ProcessPart,
    patterns: [
      /\/edit\/part\/\d+$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN"]
  }, {
    path: 'process-repair/:id',
    name: 'ProcessRepair',
    component: ProcessRepair,
    patterns: [
      /\/process-repair\/\d+$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
  }, {
    path: 'part-request/new',
    name: 'NewPartRequest',
    component: NewPartRequest,
    patterns: [
      /\/part-request\/new$/
    ],
    permissions: ["CLIENT"]
  }, {
    path: 'part-request/list',
    name: 'PartRequests',
    component: PartRequests,
    patterns: [
      /\/part-request\/list$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
  }, {
    path: 'remote-support/new',
    name: 'NewRemoteSupport',
    component: NewRemoteSupport,
    patterns: [
      /\/remote-support\/new$/
    ],
    permissions: ["CLIENT"]
  }, {
    path: 'remote-support/list',
    name: 'RemoteSupportList',
    component: RemoteSupportList,
    patterns: [
      /\/remote-support\/list$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
  }, {
    path: 'remote-support/process/:id',
    name: 'ProcessRemoteSupport',
    component: ProcessRemoteSupport,
    patterns: [
      /\/remote-support\/process\/\d+$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
  },{ 
    path: 'reset-password/:id',
    name: 'ResetPassword',
    component: ResetPassword,
    patterns: [
      /\/reset-password\/[-\d\w]+$/
    ],
    permissions: []
  }, {
    path: 'request-account/request',
    name: 'NewAccountRequest',
    component: NewAccountRequest,
    patterns: [
      /\/request-account\/request$/
    ],
    permissions: []
  }, {
    path: 'request-account/:decision/:id',
    name: 'AccountRequestDecision',
    component: AccountRequestDecision,
    patterns: [
      /\/request-account\/\w+\/\d+$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR"]
  }, {
    path: 'process-part-request/:id',
    name: 'ProcessPartRequest',
    component: ProcessPartRequest,
    patterns: [
      /\/process-part-request\/\d+$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
  }, {
    path: 'download/attachment/:id',
    name: 'DownloadAttachment',
    component: DownloadAttachment,
    patterns: [
      /\/download\/attachment\/[-\d\w]+$/
    ],
    permissions: ["ADMIN", "SUPER_ADMIN", "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
  }
]

export function findRouteByPath(path) {
  const filtered = navigationRoutes.filter(o => {
    let found = false

    for (const p of o.patterns) {
      if (new RegExp(p).test(path)) {
        found = true
        break
      }
    }

    return found
  })

  return filtered.length > 0 ? filtered[0] : null
}